import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.less']
})
export class NewServiceComponent implements OnInit {
  appLogo: string;
  navbarOpen = false;

  constructor(private router: Router) {
    this.appLogo = '../../assets/images/akrti copy.png';
  }

  ngOnInit() {
  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
